(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["download-cards"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '[data-download-cards]';

  function update(root) {
    const state = root.downloadCardsState;
    let visibleCount = 0;

    root.querySelectorAll('.directory-btn').forEach(button => {
      const active = button.dataset.directory === state.directory;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    root.querySelectorAll('.system-btn').forEach(button => {
      const active = button.dataset.system === state.system;
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', String(active));
    });

    root.querySelectorAll('.product-item').forEach(item => {
      const matchesSystem = !state.system || item.dataset.system === state.system;
      const matchesDirectory = state.directory === 'all' || item.dataset.directory === state.directory;
      const visible = (matchesSystem && matchesDirectory) || item === state.selectedCard;
      item.classList.toggle('hidden', !visible);
      item.classList.toggle('is-editor-selected', item === state.selectedCard);
      if (visible) visibleCount += 1;
    });

    root.querySelectorAll('.product-list').forEach(list => {
      const visible = Array.from(list.querySelectorAll('.product-item'))
        .some(item => !item.classList.contains('hidden'));
      const title = list.previousElementSibling;
      list.classList.toggle('hidden', !visible);
      if (title && title.classList.contains('title')) title.classList.toggle('hidden', !visible);
    });
    const empty = root.querySelector('.notFound');
    if (empty) empty.classList.toggle('hidden', visibleCount > 0);
  }

  function init(root) {
    if (!root || root.downloadCardsState) return;
    root.downloadCardsState = { system: 'windows', directory: 'all', selectedCard: null };

    root.addEventListener('click', event => {
      const directory = event.target.closest('.directory-btn');
      const system = event.target.closest('.system-btn');
      const state = root.downloadCardsState;
      if (directory && root.contains(directory)) {
        state.directory = directory.dataset.directory;
      } else if (system && root.contains(system)) {
        state.system = state.system === system.dataset.system ? '' : system.dataset.system;
      } else {
        return;
      }
      update(root);
    });

    root.addEventListener('mouseover', event => {
      const device = event.target.closest('.deviceItem[data-device-image]');
      if (!device || !root.contains(device)) return;
      const image = device.closest('.product-item').querySelector('.product-image');
      if (image) image.src = device.dataset.deviceImage;
    });
    root.addEventListener('mouseout', event => {
      const device = event.target.closest('.deviceItem[data-device-image]');
      if (!device || !root.contains(device) || device.contains(event.relatedTarget)) return;
      const image = device.closest('.product-item').querySelector('.product-image');
      if (image && image.dataset.default) image.src = image.dataset.default;
    });
    update(root);
  }

  function initAll(scope) {
    if (scope.matches && scope.matches(selector)) init(scope);
    scope.querySelectorAll(selector).forEach(init);
  }

  document.addEventListener('shopify:section:load', event => initAll(event.target));
  document.addEventListener('shopify:block:select', event => {
    const block = event.target;
    const root = block.closest(selector);
    if (!root) return;
    init(root);
    const state = root.downloadCardsState;
    const card = block.closest('.product-item');
    state.selectedCard = card && root.contains(card) ? card : null;
    if (state.selectedCard) {
      state.system = card.dataset.system;
      const hasDirectory = Array.from(root.querySelectorAll('.directory-btn'))
        .some(button => button.dataset.directory === card.dataset.directory);
      state.directory = hasDirectory ? card.dataset.directory : 'all';
    } else if (block.matches('.directory-btn')) {
      state.directory = block.dataset.directory;
    }
    update(root);
    (state.selectedCard || block).scrollIntoView({ block: 'center', behavior: 'smooth' });
  });
  document.addEventListener('shopify:block:deselect', event => {
    const root = event.target.closest(selector);
    if (!root || !root.downloadCardsState) return;
    if (!root.downloadCardsState.selectedCard || root.downloadCardsState.selectedCard !== event.target.closest('.product-item')) return;
    root.downloadCardsState.selectedCard = null;
    update(root);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
